import { FormControl, FormDescription, FormField, FormItem, FormMessage } from "@/components/ui/form"
import { Control } from "react-hook-form"
import { FormLabelWithIndicator } from "../form-label-with-indicator"
import { Switch } from "@/components/ui/switch"
import { CustomFieldProps } from '../custom-fields-container';

type CustomToggleFieldProps = CustomFieldProps & {
}

export function CustomToggleField({
  control,
  name,
  label,
  description,
  showDescription,
  info,
  required,
  isValid,
}: CustomToggleFieldProps) {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className="">
          <FormLabelWithIndicator label={label} isValid={isValid} required={required} info={info} />
          <FormControl>
            <Switch
              ref={field.ref}
              checked={field.value}
              onCheckedChange={field.onChange}
              aria-label={label}  
              aria-describedby={description ? `${name}-description` : undefined}
            />
          </FormControl>
          {showDescription && (<FormDescription id={`${name}-description`}>{description}</FormDescription>)}          
          {/* <FormMessage /> */}
        </FormItem>
      )}
    />
  )
}

